module.exports = __webpack_public_path__ + "img/dm-logo.57265a0b.png";